import mineboardBgUrl from '../assets/images/mineboard-bg.png?url'
import explosionEffectUrl from '../assets/images/explosion-effect.gif?url'
import gemIconUrl from '../assets/images/gem.png?url'
import bombIconUrl from '../assets/images/bomb.png?url'

export class AssetManager {
	private static loaded = false

	private static readonly assets: Record<string, string> = {
		mineboardBg: mineboardBgUrl,
		explosionEffect: explosionEffectUrl,
		gemIcon: gemIconUrl,
		bombIcon: bombIconUrl,
	}

	static get isLoaded() {
		return this.loaded
	}

	static getImageUrl(alias: keyof typeof AssetManager.assets) {
		return this.assets[alias]
	}

	static async loadAll(onProgress?: (progress: number) => void) {
		if (this.loaded) {
			onProgress?.(1)
			return
		}

		const entries = Object.values(this.assets)
		let completed = 0

		await Promise.all(
			entries.map(
				(src) =>
					new Promise<void>((resolve) => {
						const image = new Image()
						image.onload = () => {
							completed += 1
							onProgress?.(completed / entries.length)
							resolve()
						}
						image.onerror = () => {
							completed += 1
							onProgress?.(completed / entries.length)
							resolve()
						}
						image.src = src
					}),
			),
		)

		this.loaded = true
		onProgress?.(1)
	}
}
